const UNREGISTERED_EMAIL_MESSAGE =
  'The email address entered is not registered in our system.'

/**
 * Detects unregistered-email login failures (mobile + API message shapes).
 * Password-related errors are excluded so wrong-password stays distinct.
 */
export function isUnregisteredEmailLoginError(message: string): boolean {
  const errorLower = message.toLowerCase()
  if (errorLower.includes('password')) return false

  return (
    errorLower.includes('not registered') ||
    errorLower.includes('not found') ||
    errorLower.includes('does not exist') ||
    errorLower.includes('user not found') ||
    errorLower.includes('email not found') ||
    errorLower.includes('no user found') ||
    (errorLower.includes('invalid email') && !errorLower.includes('password'))
  )
}

export function getUnregisteredEmailLoginMessage(): string {
  return UNREGISTERED_EMAIL_MESSAGE
}

export type LoginErrorPopup = {
  title: string
  message: string
}

/**
 * Angular `login.component.ts` errorParse → notify / notifyError.
 */
export function resolveLoginErrorPopup(rawMessage: string): LoginErrorPopup {
  if (rawMessage.includes('Please retry after 30 minutes')) {
    return { title: 'Account Locked', message: rawMessage }
  }
  if (rawMessage.includes('account is Inactive due to lack of activity')) {
    return { title: 'Account Inactive', message: rawMessage }
  }
  if (isUnregisteredEmailLoginError(rawMessage)) {
    return {
      title: 'Validation Message',
      message: getUnregisteredEmailLoginMessage(),
    }
  }
  return { title: 'Validation Message', message: rawMessage }
}
